// Industry configurations for CEO Cockpit™ and C-Suite Dashboard™
// Each industry has: id, label, lucide icon name, accent color, and specific KPI/chart data

export const industries = [
  { id: 'retail', label: 'Retail', iconName: 'ShoppingBag', accent: '#0EA5E9', bg: 'bg-sky-50' },
  { id: 'supermercados', label: 'Supermercados', iconName: 'ShoppingCart', accent: '#10B981', bg: 'bg-emerald-50' },
  { id: 'negocios', label: 'Negocios', iconName: 'Store', accent: '#F59E0B', bg: 'bg-amber-50' },
  { id: 'bancos', label: 'Bancos', iconName: 'Landmark', accent: '#6366F1', bg: 'bg-indigo-50' },
  { id: 'clinicas', label: 'Clínicas', iconName: 'HeartPulse', accent: '#EC4899', bg: 'bg-pink-50' },
  { id: 'mineria', label: 'Minería', iconName: 'HardHat', accent: '#D97706', bg: 'bg-orange-50' },
  { id: 'gobierno', label: 'Gobierno', iconName: 'Building2', accent: '#0891B2', bg: 'bg-cyan-50' },
  { id: 'aeropuerto', label: 'Aeropuerto', iconName: 'Plane', accent: '#7C3AED', bg: 'bg-violet-50' },
];

// Extra KPIs (6 additional) per industry for bottom section
export const extraKpis = {
  retail: [
    { label: 'Ticket promedio', value: '$18.420' },
    { label: 'Conversión', value: '3.2%' },
    { label: 'Devoluciones', value: '1.8%' },
    { label: 'Items/ticket', value: '4.7' },
    { label: 'Clientes únicos/día', value: '2.340' },
    { label: 'Horas punta', value: '12-14h' },
  ],
  supermercados: [
    { label: 'Ticket promedio', value: '$32.150' },
    { label: 'Adopción self-checkout', value: '38%' },
    { label: 'Merma frutas', value: '2.1%' },
    { label: 'SKUs activos', value: '12.480' },
    { label: 'Cajas self-checkout', value: '124' },
    { label: 'Etiquetas ESL', value: '45.200' },
  ],
  negocios: [
    { label: 'Ticket promedio', value: '$12.800' },
    { label: 'TX mensuales', value: '8.420' },
    { label: 'Crecimiento', value: '+8.5%' },
    { label: 'Locales activos', value: '42' },
    { label: 'Hora peak', value: '18-20h' },
    { label: 'Retención cliente', value: '72%' },
  ],
  bancos: [
    { label: 'NPS sucursales', value: '68' },
    { label: 'Atención digital', value: '65%' },
    { label: 'Espera máxima', value: '12 min' },
    { label: 'Sucursales', value: '120' },
    { label: 'Turnos virtuales', value: '42%' },
    { label: 'Reclamos/mes', value: '23' },
  ],
  clinicas: [
    { label: 'Pacientes/día', value: '840' },
    { label: 'Check-in digital', value: '72%' },
    { label: 'Espera promedio', value: '8 min' },
    { label: 'Centros médicos', value: '12' },
    { label: 'Satisfacción', value: '4.5/5' },
    { label: 'No-show rate', value: '6%' },
  ],
  mineria: [
    { label: 'Toneladas/día', value: '14.200' },
    { label: 'Precisión pesaje', value: '99.7%' },
    { label: 'Camiones/día', value: '380' },
    { label: 'Faenas activas', value: '8' },
    { label: 'Temperatura prom.', value: '42°C' },
    { label: 'Uptime servidores', value: '99.9%' },
  ],
  gobierno: [
    { label: 'Trámites/día', value: '5.620' },
    { label: 'Autoatención', value: '58%' },
    { label: 'Oficinas', value: '85' },
    { label: 'Ahorro papel', value: '78%' },
    { label: 'Tiempo trámite', value: '8 min' },
    { label: 'Satisfacción', value: '4.1/5' },
  ],
  aeropuerto: [
    { label: 'Pasajeros/día', value: '28.400' },
    { label: 'Uso lockers', value: '89%' },
    { label: 'Cargas Qi/día', value: '1.240' },
    { label: 'Revenue DOOH', value: '$8.5K/d' },
    { label: 'Satisfacción PAX', value: '4.4/5' },
    { label: 'Mediciones equipaje', value: '3.200' },
  ],
};

// CEO Cockpit™ data per industry
export const ceoCockpitData = {
  retail: {
    kpis: [
      { label: 'POS online', value: 96.3, suffix: '%' },
      { label: 'Uptime 30d', value: 99.5, suffix: '%' },
      { label: 'TX hoy', value: 18420, suffix: '' },
      { label: 'Merma estimada', value: 3.1, suffix: 'M', prefix: '$' },
      { label: 'Incidentes', value: 5, suffix: '' },
      { label: 'SLA', value: 98.4, suffix: '%' },
    ],
    fleet: [{ name: 'Online', value: 842, color: '#10B981' }, { name: 'Degradado', value: 28, color: '#F59E0B' }, { name: 'Offline', value: 12, color: '#EF4444' }],
    riskPoints: [
      { local: 'Tienda Mall Plaza Vespucio', estado: 'Degradado', merma: '$1.8M', incidentes: 4, accion: 'Reemplazo lector código barras' },
      { local: 'Tienda Costanera Center', estado: 'Online', merma: '$950K', incidentes: 2, accion: 'Calibrar balanzas mostrador' },
      { local: 'Outlet Maipú', estado: 'Offline', merma: '$720K', incidentes: 5, accion: 'Despacho técnico urgente' },
      { local: 'Tienda Providencia', estado: 'Online', merma: '$480K', incidentes: 1, accion: 'Monitoreo normal' },
      { local: 'Pop-up La Serena', estado: 'Degradado', merma: '$310K', incidentes: 3, accion: 'Actualizar firmware POS' },
    ],
    insights: [
      { type: 'alert', text: 'Zona Sur tiene +22% incidentes en POS vs semana anterior.' },
      { type: 'suggestion', text: 'Priorizar reemplazo de lectores en tiendas con mayor rotación.' },
      { type: 'opportunity', text: 'Self-checkout subió ticket promedio +8% en tiendas piloto.' },
    ],
  },
  supermercados: {
    kpis: [
      { label: 'Cajas online', value: 94.8, suffix: '%' },
      { label: 'Uptime 30d', value: 99.2, suffix: '%' },
      { label: 'TX hoy', value: 45230, suffix: '' },
      { label: 'Merma estimada', value: 8.4, suffix: 'M', prefix: '$' },
      { label: 'Incidentes', value: 12, suffix: '' },
      { label: 'SLA', value: 97.8, suffix: '%' },
    ],
    fleet: [{ name: 'Online', value: 1847, color: '#10B981' }, { name: 'Degradado', value: 65, color: '#F59E0B' }, { name: 'Offline', value: 23, color: '#EF4444' }],
    riskPoints: [
      { local: 'Hiper La Florida #4', estado: 'Degradado', merma: '$4.2M', incidentes: 8, accion: 'Mantenimiento preventivo balanzas' },
      { local: 'Super Maipú Central', estado: 'Online', merma: '$2.1M', incidentes: 3, accion: 'Actualizar etiquetas ESL' },
      { local: 'Express Ñuñoa #12', estado: 'Offline', merma: '$1.5M', incidentes: 6, accion: 'Despacho técnico inmediato' },
      { local: 'Hiper Rancagua', estado: 'Degradado', merma: '$1.2M', incidentes: 4, accion: 'Revisar self-checkout' },
      { local: 'Super Las Condes', estado: 'Online', merma: '$890K', incidentes: 2, accion: 'Monitoreo normal' },
    ],
    insights: [
      { type: 'alert', text: 'Merma en frutas y verduras subió 15% — revisar calibración de balanzas.' },
      { type: 'suggestion', text: 'Activar ESL en sala de Hiper La Florida para reducir errores de precio.' },
      { type: 'opportunity', text: 'Self-checkout reduce 35% el tiempo de fila en horario punta.' },
    ],
  },
  negocios: {
    kpis: [
      { label: 'Terminales online', value: 97.1, suffix: '%' },
      { label: 'Uptime 30d', value: 99.8, suffix: '%' },
      { label: 'TX hoy', value: 3240, suffix: '' },
      { label: 'Ahorro OPEX', value: 1.2, suffix: 'M', prefix: '$' },
      { label: 'Incidentes', value: 2, suffix: '' },
      { label: 'SLA', value: 99.1, suffix: '%' },
    ],
    fleet: [{ name: 'Online', value: 156, color: '#10B981' }, { name: 'Degradado', value: 5, color: '#F59E0B' }, { name: 'Offline', value: 1, color: '#EF4444' }],
    riskPoints: [
      { local: 'Local Centro Santiago', estado: 'Online', merma: '$320K', incidentes: 1, accion: 'Monitoreo normal' },
      { local: 'Sucursal Valparaíso', estado: 'Degradado', merma: '$180K', incidentes: 2, accion: 'Actualizar software POS' },
      { local: 'Punto Venta Temuco', estado: 'Online', merma: '$95K', incidentes: 0, accion: 'Sin acción requerida' },
    ],
    insights: [
      { type: 'suggestion', text: 'Migrar a modelo arriendo reduce costos fijos en un 30%.' },
      { type: 'opportunity', text: 'POS con pantalla cliente aumenta venta cruzada +12%.' },
    ],
  },
  bancos: {
    kpis: [
      { label: 'Kioscos online', value: 98.5, suffix: '%' },
      { label: 'Uptime 30d', value: 99.9, suffix: '%' },
      { label: 'Atenciones hoy', value: 8750, suffix: '' },
      { label: 'Tiempo espera', value: 4.2, suffix: 'min' },
      { label: 'Incidentes', value: 3, suffix: '' },
      { label: 'SLA', value: 99.5, suffix: '%' },
    ],
    fleet: [{ name: 'Online', value: 520, color: '#10B981' }, { name: 'Degradado', value: 8, color: '#F59E0B' }, { name: 'Offline', value: 2, color: '#EF4444' }],
    riskPoints: [
      { local: 'Sucursal Plaza de Armas', estado: 'Degradado', merma: '-', incidentes: 3, accion: 'Actualizar software turnero' },
      { local: 'Sucursal Providencia', estado: 'Online', merma: '-', incidentes: 1, accion: 'Revisar pantalla digital' },
      { local: 'Sucursal Temuco', estado: 'Online', merma: '-', incidentes: 0, accion: 'Monitoreo normal' },
    ],
    insights: [
      { type: 'alert', text: 'Sucursal Plaza de Armas: espera promedio supera 8 minutos en horario punta.' },
      { type: 'suggestion', text: 'Implementar turno virtual reduce espera en sucursal un 40%.' },
      { type: 'opportunity', text: 'Autoatención resuelve 65% de trámites sin ejecutivo.' },
    ],
  },
  clinicas: {
    kpis: [
      { label: 'Kioscos online', value: 99.1, suffix: '%' },
      { label: 'Uptime 30d', value: 99.7, suffix: '%' },
      { label: 'Check-in hoy', value: 1240, suffix: '' },
      { label: 'Tiempo espera', value: 5.8, suffix: 'min' },
      { label: 'Incidentes', value: 1, suffix: '' },
      { label: 'SLA', value: 99.3, suffix: '%' },
    ],
    fleet: [{ name: 'Online', value: 85, color: '#10B981' }, { name: 'Degradado', value: 2, color: '#F59E0B' }, { name: 'Offline', value: 0, color: '#EF4444' }],
    riskPoints: [
      { local: 'Clínica Las Condes', estado: 'Online', merma: '-', incidentes: 1, accion: 'Actualizar integración HIS' },
      { local: 'Hospital Regional', estado: 'Degradado', merma: '-', incidentes: 2, accion: 'Revisar impresora brazalete' },
    ],
    insights: [
      { type: 'suggestion', text: 'Check-in automático reduce carga de admisión en un 45%.' },
      { type: 'opportunity', text: 'Señalética digital mejora la orientación de pacientes.' },
    ],
  },
  mineria: {
    kpis: [
      { label: 'Equipos online', value: 92.4, suffix: '%' },
      { label: 'Uptime 30d', value: 98.8, suffix: '%' },
      { label: 'Pesajes hoy', value: 2840, suffix: '' },
      { label: 'Desviación peso', value: 0.3, suffix: '%' },
      { label: 'Incidentes', value: 4, suffix: '' },
      { label: 'SLA', value: 97.5, suffix: '%' },
    ],
    fleet: [{ name: 'Online', value: 78, color: '#10B981' }, { name: 'Degradado', value: 5, color: '#F59E0B' }, { name: 'Offline', value: 2, color: '#EF4444' }],
    riskPoints: [
      { local: 'Faena Antofagasta', estado: 'Degradado', merma: '$2.1M', incidentes: 3, accion: 'Calibración urgente balanzas' },
      { local: 'Planta Calama', estado: 'Online', merma: '$850K', incidentes: 1, accion: 'Mantenimiento preventivo' },
      { local: 'Campamento Atacama', estado: 'Offline', merma: '$1.4M', incidentes: 4, accion: 'Revisar conectividad satelital' },
    ],
    insights: [
      { type: 'alert', text: 'Faena Antofagasta: desviación de pesaje fuera de rango — calibrar urgente.' },
      { type: 'suggestion', text: 'Servidores Edge reducen latencia en faenas remotas un 60%.' },
      { type: 'opportunity', text: 'Automatización de registro reduce errores humanos en 80%.' },
    ],
  },
  gobierno: {
    kpis: [
      { label: 'Kioscos online', value: 95.8, suffix: '%' },
      { label: 'Uptime 30d', value: 99.4, suffix: '%' },
      { label: 'Atenciones hoy', value: 5620, suffix: '' },
      { label: 'Ahorro OPEX', value: 12.5, suffix: 'M', prefix: '$' },
      { label: 'Incidentes', value: 6, suffix: '' },
      { label: 'SLA', value: 98.2, suffix: '%' },
    ],
    fleet: [{ name: 'Online', value: 340, color: '#10B981' }, { name: 'Degradado', value: 12, color: '#F59E0B' }, { name: 'Offline', value: 3, color: '#EF4444' }],
    riskPoints: [
      { local: 'Oficina Registro Civil RM', estado: 'Degradado', merma: '-', incidentes: 4, accion: 'Actualizar turnero' },
      { local: 'Municipalidad Valpo', estado: 'Online', merma: '-', incidentes: 2, accion: 'Revisar cartelería digital' },
      { local: 'SAG Aeropuerto', estado: 'Online', merma: '-', incidentes: 1, accion: 'Monitoreo normal' },
    ],
    insights: [
      { type: 'suggestion', text: 'Modelo OPEX permite ejecutar presupuesto sin inversión de capital.' },
      { type: 'opportunity', text: 'Autoatención reduce tiempo de trámite de 25 a 8 minutos.' },
    ],
  },
  aeropuerto: {
    kpis: [
      { label: 'Estaciones online', value: 97.6, suffix: '%' },
      { label: 'Uptime 30d', value: 99.6, suffix: '%' },
      { label: 'Cargas hoy', value: 4120, suffix: '' },
      { label: 'Ingresos ads', value: 8.5, suffix: 'K/día', prefix: '$' },
      { label: 'Incidentes', value: 2, suffix: '' },
      { label: 'SLA', value: 99.2, suffix: '%' },
    ],
    fleet: [{ name: 'Online', value: 245, color: '#10B981' }, { name: 'Degradado', value: 6, color: '#F59E0B' }, { name: 'Offline', value: 1, color: '#EF4444' }],
    riskPoints: [
      { local: 'Terminal Internacional Gate A', estado: 'Degradado', merma: '-', incidentes: 2, accion: 'Reemplazo cable USB locker #12' },
      { local: 'Terminal Nacional Sala B', estado: 'Online', merma: '-', incidentes: 1, accion: 'Limpieza cargadores Qi' },
      { local: 'VIP Lounge', estado: 'Online', merma: '-', incidentes: 0, accion: 'Monitoreo normal' },
    ],
    insights: [
      { type: 'alert', text: 'Gate A: 2 lockers sin servicio — pasajeros reclamando en redes.' },
      { type: 'suggestion', text: 'DOOH en zona embarque genera USD 8.5K/día en publicidad.' },
      { type: 'opportunity', text: 'Kioscos de medición de equipaje reducen conflictos en gate 70%.' },
    ],
  },
};

// Transaction chart generator per industry
export const generateTxData = (industry) => {
  const base = {
    retail: 8000, supermercados: 20000, negocios: 1500, bancos: 4000,
    clinicas: 600, mineria: 1200, gobierno: 2500, aeropuerto: 2000,
  };
  const b = base[industry] || 5000;
  return Array.from({ length: 30 }, (_, i) => ({
    day: `${i + 1}`,
    tx: Math.floor(b + Math.random() * (b * 0.4) + (i > 20 ? b * 0.15 : 0)),
  }));
};

export const generateIncidentsData = (industry) => {
  const regions = {
    retail: ['RM', 'Valpo', 'Bio-Bio', 'Araucanía', 'Antofagasta'],
    supermercados: ['RM', 'Valpo', 'Bio-Bio', 'Maule', 'Coquimbo'],
    negocios: ['RM', 'Valpo', 'Concepción'],
    bancos: ['RM', 'Valpo', 'Concepción', 'Temuco', 'Antofagasta'],
    clinicas: ['RM', 'Valpo', 'Concepción'],
    mineria: ['Antofagasta', 'Atacama', 'Coquimbo', 'Tarapacá'],
    gobierno: ['RM', 'Valpo', 'Bio-Bio', 'Araucanía', 'Los Lagos'],
    aeropuerto: ['SCL', 'Calama', 'Concepción', 'Iquique'],
  };
  return (regions[industry] || regions.retail).map(r => ({
    region: r,
    incidents: Math.floor(2 + Math.random() * 12),
  }));
};
